// Ordenação de agendamentos por data + horário — UI padrão global.
// Comparo as strings "YYYY-MM-DD HH:MM:SS" tal como o sistema armazena
// (data e horário locais do estabelecimento). Comparação lexicográfica de
// data+hora ISO = ordem cronológica, sem parsing/timezone — é a forma mais
// segura em relação a fuso, porque não converte para Date nem desloca por UTC.

export function bookingDateTimeKey(b: any): string {
  const date = (b && b.date) ? String(b.date) : '';
  const time = (b && b.start_time) ? String(b.start_time) : '';
  return `${date} ${time}`;
}

// Comparador ascendente (mais cedo primeiro).
export function compareBookingDateTimeAsc(a: any, b: any): number {
  const ka = bookingDateTimeKey(a);
  const kb = bookingDateTimeKey(b);
  return ka < kb ? -1 : ka > kb ? 1 : 0;
}

// Próximos: crescente (o primeiro é o "próximo horário"). Não muta a entrada.
export function sortUpcomingAsc<T = any>(list: T[]): T[] {
  return [...(list || [])].sort(compareBookingDateTimeAsc);
}

// Histórico: decrescente (mais recente primeiro). Não muta a entrada.
export function sortPastDesc<T = any>(list: T[]): T[] {
  return [...(list || [])].sort((a, b) => compareBookingDateTimeAsc(b, a));
}
